import React, { useState, useEffect } from "react";
import { ToggleIcon } from "./common/ToggleIcon";
import { FaRegCheckCircle, FaRegCircle } from "react-icons/fa";
import { validateNhsno } from "../utils";
import { QuestionnaireHeader } from "./QuestionnaireHeader";
import { QuestionnaireFooter } from "./QuestionnaireFooter";

const areEqual = (prevProps, nextProps) => {
	if (
		prevProps.def === nextProps.def &&
		prevProps.currentResponse === nextProps.currentResponse
	) {
		return true;
	} else {
		return false;
	}
};

export const QuestionnaireEmailNhsPage = React.memo(
	({ def, onRespond, currentResponse }) => {
		const [nhsNo, setNhsNo] = useState("");
		const [email, setEmail] = useState("");
		const [consentDate, setConsentDate] = useState();
		const [nhsnoIcon, setNhsnoIcon] = useState();

		const submitResponse = (email, nhsNo, consentDate) => {
			const response = {
				id: def.id,
				value: {
					email,
					nhsNo,
					consentDate,
				},
			};
			onRespond(response);
		};

		useEffect(() => {
			submitResponse(email, nhsNo, consentDate);
		}, [email, nhsNo, consentDate]);

		useEffect(() => {
			const formatNhsNo = (nhs) => {
				let ret = "";
				if (nhs.trim()) {
					ret = nhs.trim();
					ret = `${ret.substring(0, 3)} ${ret.substring(3, 6)} ${ret.substring(
						6,
						ret.length
					)}`;
				}
				return ret;
			};

			if (currentResponse) {
				let {
					email = "",
					nhsNo = "",
					consentDate = null,
				} = currentResponse.value;

				nhsNo = nhsNo.replace(/\s/g, "");

				setEmail(email);
				setNhsNo(formatNhsNo(nhsNo));
				setConsentDate(consentDate);
				setNhsnoIcon(
					nhsNo.length === 0 ? null : validateNhsno(nhsNo) ? "tick" : "cross"
				);
			} else {
				const _selectedOption = { email: "", nhsNo: "", consentDate: null };

				if (def.answer) {
					_selectedOption.email = def.answer.email || _selectedOption.email;
					_selectedOption.nhsNo = (
						def.answer.nhsNo || _selectedOption.nhsNo
					).replace(/\s/g, "");
					_selectedOption.consentDate =
						def.answer.consentDate || _selectedOption.consentDate;
				}

				setEmail(_selectedOption.email);
				setNhsNo(formatNhsNo(_selectedOption.nhsNo));
				setConsentDate(_selectedOption.consentDate);
				setNhsnoIcon(
					_selectedOption.nhsNo.length === 0
						? null
						: validateNhsno(_selectedOption.nhsNo)
						? "tick"
						: "cross"
				);

				submitResponse(
					_selectedOption.email,
					_selectedOption.nhsNo,
					_selectedOption.consentDate
				);
			}
		}, []); // [currentResponse, def, onRespond]);

		const onNhsNoChange = (e) => {
			const value = e.target.value.replace(/[^0-9,\s]/g, "");
			setNhsNo(e.target.value);

			// does it look valid
			if (value.trim().length === 0) {
				setNhsnoIcon();
			} else {
				setNhsnoIcon(
					validateNhsno(value.replace(/\s/g, "")) ? "tick" : "cross"
				);
			}
		};

		const onEmailChange = (e) => {
			const value = e.target.value.replace(/ /g, "");
			setEmail(value);
		};

		return (
			<>
				<QuestionnaireHeader def={def} />

				<div className={"formInputContainer mt-10 mb-3 mx-3"}>
					<label className={"basicFormLabel text-black"} htmlFor={"email"}>
						{def.emailLabel || "Email"}
						<sup>*</sup>
					</label>
					<input
						type="email"
						className={"formField"}
						id="email"
						name="email"
						value={email}
						onChange={onEmailChange}
						placeholder="Email address"
					/>
				</div>

				<div className={"formInputContainer mb-6 mx-3"}>
					<label className={"basicFormLabel text-black"} htmlFor={"nhsno"}>
						{def.nhsnoLabel || "NHS/CHI no."}
						<sup>*</sup>
					</label>
					<div className="relative">
						<input
							type="text"
							className={"formField"}
							id="nhsno"
							name="nhsno"
							value={nhsNo}
							onChange={onNhsNoChange}
							placeholder="NHS / CHI number - 10 digits"
						/>
						<ToggleIcon
							selection={nhsnoIcon}
							classes="ml-2 text-xl absolute right-2 top-3"
							colours={{ tick: "green", cross: "red" }}
						/>
					</div>
				</div>
				<div
					className={
						"text-left pb-4 border-b-2 border-slate-400 border-opacity-50 mx-3"
					}
				>
					<div className={"mx-auto flex justify-between items-center"}>
						<p className={"font-bold w-4/5 text-black"}>
							{def.consentLabel ||
								`Please confirm you have the patient's consent to register them for the Companion App by ticking here`}
							:
						</p>

						{consentDate ? (
							<FaRegCheckCircle
								onClick={() => {
									setConsentDate(consentDate ? null : new Date().getTime());
								}}
								className={"text-3xl text-gray-600"}
							/>
						) : (
							<FaRegCircle
								onClick={() => {
									setConsentDate(consentDate ? null : new Date().getTime());
								}}
								className={"text-3xl text-gray-400"}
							/>
						)}
					</div>
				</div>

				<QuestionnaireFooter def={def} />
			</>
		);
	},
	areEqual
);
